import { BG_STYLES, COLORS, COMMON_STYLES, TEXT_STYLES, TYPOGRAPHY, VARIANTS_STYLES } from '@dehaat/dds'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  headerWrap: {
    width: '100%',
    maxWidth: 960,
    alignSelf: 'center',
    paddingHorizontal: 16,
    paddingTop: 10,
    paddingBottom: 8,
  },
  filterRow: {
    maxHeight: 52,
  },
  filterContent: {
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: 8,
  },
  filterBtn: {
    borderWidth: 1,
    padding: 6,
  },
  listDesktop: {
    alignSelf: 'center',
    width: '100%',
    maxWidth: 960,
    paddingHorizontal: 0,
    paddingTop: 4,
    paddingBottom: 92,
  },
  listMobile: {
    paddingHorizontal: 0,
    paddingTop: 4,
    paddingBottom: 92,
  },
  card: {
    padding: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderTopColor: COLORS.neutral20,
    borderBottomColor: COLORS.neutral20,
    marginBottom: 4,
  },
  requestTopRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsStart,
    columnGap: 12,
  },
  requestProductBlock: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.flex1,
    columnGap: 12,
  },
  requestProductImageWrap: {
    width: 64,
    height: 64,
    borderRadius: 8,
    overflow: 'hidden',
  },
  requestProductImage: {
    width: 64,
    height: 64,
  },
  requestProductInfo: {
    flex: 1,
    minWidth: 0,
  },
  requestBrandText: {
    ...TYPOGRAPHY.CAPTION1,
    ...VARIANTS_STYLES.MEDIUM,
    ...TEXT_STYLES.textNeutral70,
  },
  requestProductName: {
    ...TYPOGRAPHY.TEXT1,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    ...TEXT_STYLES.textNeutral90,
  },
  requestVariantText: {
    ...TYPOGRAPHY.TEXT1,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    ...TEXT_STYLES.textNeutral90,
  },
  requestMetaCol: {
    width: 120,
    rowGap: 4,
    paddingTop: 2,
  },
  requestTypePill: {
    height: 20,
    borderRadius: 16,
    backgroundColor: COLORS.neutral10,
    alignSelf: 'stretch',
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyCenter,
    paddingHorizontal: 8,
  },
  requestTypePillText: {
    ...TYPOGRAPHY.CAPTION2,
    ...VARIANTS_STYLES.BASE,
    ...TEXT_STYLES.textNeutral90,
  },
  requestStatusRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    columnGap: 4,
  },
  requestStatusLabel: {
    ...TYPOGRAPHY.CAPTION2,
    ...VARIANTS_STYLES.BASE,
    ...TEXT_STYLES.textNeutral70,
  },
  cardDivider: {
    marginTop: 12,
    marginBottom: 12,
    height: 1,
    backgroundColor: COLORS.neutral20,
  },
  requestSection: {
    rowGap: 2,
    marginBottom: 8,
  },
  requestSectionTitle: {
    ...TYPOGRAPHY.TEXT2,
    ...VARIANTS_STYLES.BASE,
    ...TEXT_STYLES.textNeutral90,
  },
  requestSectionItem: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    columnGap: 8,
  },
  requestSectionIconWrap: {
    width: 24,
    height: 24,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyCenter,
  },
  requestSectionTextWrap: {
    ...COMMON_STYLES.flex1,
  },
  infoRow: {
    ...COMMON_STYLES.row,
    columnGap: 4,
    ...COMMON_STYLES.alignItemsCenter,
  },
  infoLabel: {
    width: 80,
    ...TYPOGRAPHY.CAPTION2,
    ...VARIANTS_STYLES.BASE,
    ...TEXT_STYLES.textNeutral70,
  },
  infoValue: {
    ...COMMON_STYLES.flex1,
    ...TYPOGRAPHY.CAPTION2,
    ...VARIANTS_STYLES.BASE,
    ...TEXT_STYLES.textNeutral90,
  },
  requestSectionPrimaryText: {
    ...TYPOGRAPHY.TEXT1,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    ...TEXT_STYLES.textNeutral90,
  },
  requestSectionSecondaryText: {
    ...TYPOGRAPHY.CAPTION1,
    ...VARIANTS_STYLES.MEDIUM,
    ...TEXT_STYLES.textNeutral70,
  },
  saleOrderWrap: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.justifyBetween,
    ...COMMON_STYLES.alignItemsCenter,
    marginTop: 2,
    marginBottom: 8,
  },
  approvedByYouWrap: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    columnGap: 4,
    ...COMMON_STYLES.flex1,
  },
  approvedByYouText: {
    ...TYPOGRAPHY.CAPTION1,
    ...VARIANTS_STYLES.MEDIUM,
    color: COLORS.success100,
  },
  saleOrderDetailWrap: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.justifyStart,
    marginTop: 4,
    marginBottom: 8,
  },
  saleOrderChip: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    backgroundColor: '#F1FFEB',
    borderColor: '#F1FFEB',
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  saleOrderLabel: {
    fontSize: 10,
    lineHeight: 14,
    fontWeight: '400',
    color: '#80868C',
  },
  saleOrderValue: {
    fontSize: 12,
    lineHeight: 14,
    fontWeight: '500',
    color: '#171B1F',
  },
  approverInfoRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    columnGap: 4,
    marginBottom: 4,
  },
  approverStatusText: {
    ...TYPOGRAPHY.CAPTION1,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    ...COMMON_STYLES.flex1,
    textAlign: 'right',
  },
  approverStatusApproved: {
    color: COLORS.success100,
  },
  approverStatusPending: {
    color: COLORS.yellow100,
  },
  approverStatusRejected: {
    color: COLORS.error100,
  },
  approverStatusNeutral: {
    color: COLORS.neutral70,
  },
  statusPill: {
    minWidth: 82,
    height: 20,
    borderRadius: 16,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyCenter,
    paddingHorizontal: 8,
  },
  statusPillPending: {
    backgroundColor: '#FFBB00',
  },
  statusPillApproved: {
    backgroundColor: '#43A314',
  },
  statusPillRejected: {
    backgroundColor: '#D12F2F',
  },
  statusPillUnknown: {
    backgroundColor: COLORS.neutral40,
  },
  statusPillText: {
    ...TYPOGRAPHY.CAPTION2,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
  },
  statusPillTextPending: {
    color: '#171B1F',
  },
  statusPillTextApproved: {
    color: COLORS.white,
  },
  statusPillTextRejected: {
    color: COLORS.white,
  },
  statusPillTextUnknown: {
    color: COLORS.neutral90,
  },
  statusChip: {
    backgroundColor: '#f8e047',
    borderWidth: 0,
    borderColor: 'transparent',
  },
  emptyState: {
    ...COMMON_STYLES.flex1,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyCenter,
    paddingVertical: 30,
  },
  ctaWrap: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    maxWidth: 960,
    alignSelf: 'center',
    paddingTop: 12,
    paddingHorizontal: 16,
    paddingBottom: 12,
  },
  ctaInner: {
    width: '100%',
  },
  detailSheetWrap: {
    paddingBottom: 8,
  },
  detailTopRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsStart,
    marginBottom: 12,
  },
  detailProductRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.flex1,
    columnGap: 10,
  },
  detailMetaCol: {
    width: 250,
    ...COMMON_STYLES.alignItemsEnd,
    marginLeft: 8,
    paddingTop: 4,
  },
  detailProductImage: {
    width: 56,
    height: 56,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.neutral20,
  },
  detailBrandText: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textNeutral70,
  },
  detailProductName: {
    ...TYPOGRAPHY.HEADING3,
    ...TEXT_STYLES.textNeutral90,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
  },
  detailVariantText: {
    ...TYPOGRAPHY.HEADING3,
    ...TEXT_STYLES.textNeutral90,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
  },
  closeBtn: {
    width: 28,
    height: 28,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyCenter,
  },
  closeBtnText: {
    fontSize: 30,
    lineHeight: 30,
    color: '#464C52',
  },
  detailTagRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    marginBottom: 8,
  },
  requestTypeChip: {
    backgroundColor: COLORS.neutral10,
  },
  requestTypeChipLabel: {
    ...TYPOGRAPHY.CAPTION2,
    ...VARIANTS_STYLES.MEDIUM,
  },
  statusRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    columnGap: 6,
  },
  statusLabel: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textNeutral70,
  },
  statusChipLabel: {
    ...TYPOGRAPHY.CAPTION2,
    ...VARIANTS_STYLES.MEDIUM,
  },
  issueForTitle: {
    ...TYPOGRAPHY.HEADING3,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    ...TEXT_STYLES.textNeutral90,
  },
  detailDivider: {
    height: 1,
    backgroundColor: COLORS.neutral20,
    marginVertical: 8,
  },
  issueRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
  },
  issueItem: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    columnGap: 8,
    marginBottom: 8,
    flex: 1,
  },
  issueText: {
    ...TYPOGRAPHY.TEXT2,
    ...TEXT_STYLES.textNeutral90,
    flexShrink: 1,
  },
  issueIconSlot: {
    width: 24,
    height: 24,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyCenter,
  },
  issueMiniDivider: {
    width: 1,
    height: 20,
    backgroundColor: COLORS.neutral20,
    marginHorizontal: 10,
  },
  multiRow: {
    paddingTop: 8,
    alignItems: 'center',
  },
  checkbox: {
    borderRadius: 3,
  },
  checkboxWrap: {
    position: 'absolute',
    top: 10,
    left: 8,
    zIndex: 1,
  },
  selectAllText: {
    ...TYPOGRAPHY.CAPTION1,
    ...VARIANTS_STYLES.MEDIUM,
    ...TEXT_STYLES.textNeutral90,
  },
  actionBtn: {
    flex: 1,
    borderColor: 'transparent',
    paddingVertical: 18,
  },
  detailActionBtn: {
    flex: 1,
    borderColor: 'transparent',
    paddingVertical: 16,
    marginTop: 8,
  },
  image16x16: {
    width: 16,
    height: 16,
  },
  bulkActionWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    ...COMMON_STYLES.row,
    ...BG_STYLES.bgWhite,
    padding: 12,
    gap: 8,
    borderTopColor: COLORS.neutral20,
    borderTopWidth: 1,
  },
  bulkActionBtn: {
    flex: 1,
    borderColor: 'transparent',
    paddingVertical: 18,
  },
  modalBtn: {
    borderColor: 'transparent',
    paddingVertical: 18,
  },
  reasonRow: {
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    marginTop: 10,
  },
  reasonLabel: {
    ...TYPOGRAPHY.TEXT2,
    ...TEXT_STYLES.textNeutral80,
    ...COMMON_STYLES.flex1,
  },
  reasonInputContainer: {
    marginTop: 12,
    borderColor: COLORS.neutral40,
  },
  validationErrorText: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textError100,
    marginTop: 8,
  },
})

export default styles
